const QUERIES = {
  USERS_LIST: 'users-list',
  STREAM_RTC_LIST: 'stream-rtc',
  USERS: 'users-list',
  GROUP: 'group',
  ADDRESS: 'address'
}

export { QUERIES }
